app.controller('baseOfCaseVisitCardController', ['$scope', '$state', '$stateParams', '$translate', 'objectHelper', 'baseModel', 'applicationModel', 'visitModel', 'userModel', 'patientModel', 'allergyModel', 'vaccinationAndSerumModel', 'takenDrugModel', 'geneticDisorderModel', 'baseOfCaseModel',
    function ($scope, $state, $stateParams, $translate, objectHelper, baseModel, applicationModel, visitModel, userModel, patientModel, allergyModel, vaccinationAndSerumModel, takenDrugModel, geneticDisorderModel, baseOfCaseModel) {

        function setData() {
            $scope.activeVisitCard = {};
            $scope.isPreview = true;
            $scope.idVisitCard = $stateParams.idVisitCard;
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on(Event.BASE_OF_CASE.GET_ANONYMIZED_VISIT_CARD.SUCCESS, function(event, visitCard) {
                $scope.activeVisitCard = visitCard;
                if($scope.activeVisitCard && $scope.activeVisitCard.prescribedDrugs) {
                    $scope.localOtcDrugs = [];
                    $scope.activeVisitCard.prescribedDrugs.forEach(function (otcDrug) {
                        $scope.localOtcDrugs.push({otcDrug: otcDrug, packages: [otcDrug.drug.packing], noPackages: true});
                    });
                }
            });

        }

        function setActions() {
            $scope.goToSearchPage = function () {
                $state.go(Constant.STATE.APP.BASE_OF_CASE.SEARCH);
            };
        }

        function configureInterface() {
        }

        function initialize() {
            baseOfCaseModel.getAnonymizedVisitCard($stateParams.idVisitCard);
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        initialize();
        configureInterface();
    }
]);